module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-580-7498fa16771e80f0afedc749a5077019.jpg";